import axios from 'axios';

import {
    API_BASE_URL
} from '../constants/index';

export default class ShareholdersService {
	static instance;

	static getInstance() {
		if (!ShareholdersService.instance) {
			ShareholdersService.instance = new ShareholdersService();
		}

		return ShareholdersService.instance;
	}

    async fetchList(supplierId, params = {}){
        const response = await axios.get(`${API_BASE_URL}/share_holder/supplier/${supplierId}/list`, {
            params  :   params,
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            },
        });

        return response.data.data;
    }

    async create(payload){
        const response = await axios.post(`${API_BASE_URL}/share_holder/add`, payload,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
              },
            }
        );
  
        return response.data.data;
    }

    async update(shareholderId, payload){
        const response = await axios.post(`${API_BASE_URL}/share_holder/edit/${shareholderId}`, payload,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
              },
            }
        );
  
        return response.data.data;
    }

    async delete(shareholderId){
        const response = await axios.delete(`${API_BASE_URL}/share_holder/remove/${shareholderId}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
              },
            }
        );
  
        return response.data?.data || null;
    }
}
